import React from 'react';
import { Box, Container, Typography, Grid, Paper, Avatar, IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const LeadershipTeam = () => {
  const team = [
    {
      name: 'Alex Developer',
      role: 'CEO & Fundador',
      desc: 'Arquitecto principal de la visión del ecosistema Hitpoly. Con experiencia en escalabilidad B2B y automatización.',
      initial: 'AD',
      color: '#6C4DE2'
    },
    {
      name: 'María Innovator',
      role: 'Directora de Academia',
      desc: 'Encargada de diseñar los currículos formativos y asegurar que los profesionales adquieran habilidades 100% rentables.',
      initial: 'MI',
      color: '#F21C63'
    },
    {
      name: 'David Tech',
      role: 'CTO & Arquitectura',
      desc: 'Líder técnico responsable de que el CRM, el Scraping y la Bolsa funcionen con latencia cero y máxima seguridad.',
      initial: 'DT',
      color: '#00A86B'
    },
    {
      name: 'Laura Connect',
      role: 'Directora de Comunidad',
      desc: 'Garantiza el éxito de las conexiones B2B y fomenta un ambiente de colaboración sinérgica en el ecosistema.',
      initial: 'LC',
      color: '#E67E22'
    }
  ];

  return (
    <Box sx={{ background: '#13111C', py: { xs: 10, md: 16 }, color: '#fff', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Container maxWidth="lg">
        
        <Box textAlign="center" mb={10}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Typography variant="caption" sx={{ color: '#29B6F6', fontWeight: 'bold', letterSpacing: 3, textTransform: 'uppercase' }}>
              Los Arquitectos del Ecosistema
            </Typography>
            <Typography variant="h2" fontWeight={900} mt={2} mb={3}>
              Liderazgo Profesional
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 700, mx: 'auto', fontSize: '1.2rem' }}>
              Personas reales, con experiencia real. Un equipo directivo comprometido con llevar tu carrera y tu empresa al siguiente nivel.
            </Typography>
          </motion.div>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {team.map((member, index) => (
            <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: 'flex' }}>
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                style={{ width: '100%', display: 'flex' }}
              >
                <Paper 
                  elevation={0}
                  sx={{ 
                    p: 0, 
                    background: 'rgba(255,255,255,0.02)', 
                    border: '1px solid rgba(255,255,255,0.05)', 
                    borderRadius: '24px',
                    textAlign: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.4s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      borderColor: member.color,
                      boxShadow: `0 20px 40px rgba(${parseInt(member.color.slice(1, 3), 16)}, ${parseInt(member.color.slice(3, 5), 16)}, ${parseInt(member.color.slice(5, 7), 16)}, 0.15)`
                    }
                  }}
                >
                  {/* Decorative Header */}
                  <Box sx={{ height: '80px', flexShrink: 0, background: `linear-gradient(135deg, ${member.color} 0%, rgba(255,255,255,0) 100%)`, opacity: 0.2 }} />
                  
                  <Box sx={{ px: 3, pb: 4, pt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', mt: -6, flexGrow: 1 }}>
                    <Avatar 
                      sx={{ 
                        width: 100, 
                        height: 100, 
                        mb: 3, 
                        bgcolor: '#13111C',
                        color: member.color,
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        border: `3px solid ${member.color}`,
                        boxShadow: '0 10px 20px rgba(0,0,0,0.5)'
                      }}
                    >
                      {member.initial}
                    </Avatar>
                    <Typography variant="h5" fontWeight="bold" mb={0.5}>{member.name}</Typography>
                    <Typography variant="subtitle2" sx={{ color: member.color, fontWeight: 'bold', mb: 3, textTransform: 'uppercase', letterSpacing: 1 }}>{member.role}</Typography>
                    
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, mb: 4, flexGrow: 1 }}>
                      {member.desc}
                    </Typography>

                    <Box display="flex" gap={1}>
                      <IconButton sx={{ color: 'rgba(255,255,255,0.5)', '&:hover': { color: '#0077b5', background: 'rgba(255,255,255,0.1)' } }}>
                        <LinkedInIcon />
                      </IconButton>
                      <IconButton sx={{ color: 'rgba(255,255,255,0.5)', '&:hover': { color: '#fff', background: 'rgba(255,255,255,0.1)' } }}>
                        <EmailIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
};

export default LeadershipTeam;
